// Header.js
import React, { useState, useEffect, useRef, Fragment } from 'react';
import { DialogBackdrop, Menu, MenuButton, MenuItem, MenuItems, Transition, TransitionChild } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import { Button, Dialog, DialogPanel, Popover, PopoverButton, PopoverGroup, PopoverPanel } from '@headlessui/react'
import {
  Bars3Icon,
  XMarkIcon,
} from '@heroicons/react/24/outline'
import "../commonSection/commonsection.css";
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import CopyToClipboard from 'react-copy-to-clipboard';
import { Link45deg } from 'react-bootstrap-icons';
import SmallCarousel from '../carouselSection/SmallCarousel';
import LinkedInImg from "../../assets/icon_1/in.png"
import EmailIconImg from "../../assets/icon_1/msg.png"
import PhoneIconImg from "../../assets/icon_1/call.png"
import WhatsappIconImg from "../../assets/icon_1/wh.png"
import Facebookmg from "../../assets/icon_1/fb.png"
import TwitterImg from "../../assets/icon_1/x.png"
import toast from "react-hot-toast";
import { isMobile } from 'react-device-detect';

const Header = () => {
    const headerRef = useRef();
    const [activeSection, setActiveSection] = useState('');
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
    const [openCategory, setOpenCategory] = useState(false)
    const navigate = useNavigate();
    const home_data = useSelector((state) => state.microsite?.home_data);
    const profile_data = useSelector((state) => state.microsite?.home_data?.microsite);
    const achivements = useSelector((state) => state.microsite?.home_data?.achivements);
    const category = useSelector((state) => state.microsite?.home_data?.category);
    const theme_colors = useSelector((state) => state.microsite?.theme_colors);
    
    const siteColors = {
        primary: theme_colors?.primary,
        secondary: theme_colors?.secondary,
        textMuted: "#00000070"
    };
    
    // Show loader when header profile info isn't ready
    const showHeaderLoader = (
        !home_data?.microsite?.name || home_data?.microsite?.name === '' ||
        !home_data?.microsite?.profile_image || home_data?.microsite?.profile_image === ''
    );

    // When registration details are shown the header text block is taller, so
    // the profile image is enlarged to match it.
    const showRegistrationAtHeader = home_data?.new_microsite_extra_clt?.registration_name_at_new_microsite_header === 1;
    const headerAvatarSizeClass = showRegistrationAtHeader ? "h-20 w-20" : "h-10 w-10";
    
    const scrollToSection = (id) => {
        const section = document.getElementById(id);
        const headerOffset = headerRef?.current?.offsetHeight; // Adjust based on the header height
        const elementPosition = section.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - headerOffset;

        window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
        });
    };

    function setFavicon(url) {
        let link = document.querySelector("link[rel~='icon']");
        if (!link) {
          link = document.createElement('link');
          link.rel = 'icon';
          document.head.appendChild(link);
        }
        link.href = url;
    }
    
    function classNames(...classes) {
        return classes.filter(Boolean).join(" ");
    }

    const getDistributorLoginUrl = () => {
        try {
            const currentUrl = new URL(window.location.href);
            const trd = currentUrl.searchParams.get('trd');
            const hostParts = currentUrl.hostname.split('.');
            const baseDomain = hostParts.length >= 2 ? hostParts.slice(-2).join('.') : currentUrl.hostname;
            const appHost = `app.${baseDomain}`;
            const baseLoginUrl = `${currentUrl.protocol}//${appHost}`;
            if (trd) {
                const params = new URLSearchParams({ trd });
                return `${baseLoginUrl}?${params.toString()}`;
            }
            return baseLoginUrl;
        } catch (error) {
            return 'https://app.sptestmfp.com/home';
        }
    };

    const handleDistributorLogin = () => {
        const loginUrl = getDistributorLoginUrl();
        window.location.href = loginUrl+'/home';
    };

    const handleDistributorLoginMobile = () => {
        const loginUrl = getDistributorLoginUrl();
        window.location.href = loginUrl+'/login.php?source=microsite&ref=home&app=play_store';
    };


    const handleNavigation = (section) => {
        if (mobileMenuOpen) {
            setMobileMenuOpen(false);
        }

        if (window.location.href.includes("/category")) {
            navigate("/")
             window.scrollTo({
                top: 0,
            });
            setTimeout(() => {
                scrollToSection(section)
            }, 1000);
        } else {
            scrollToSection(section)
        } 
    }
    
    const handleRedirect = (address) => {
        if (address.trim()) {
        const encodedAddress = encodeURIComponent(address);
        const url = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
        const newWindow = window.open(url, '_blank');
            if (newWindow) {
                newWindow.opener = null;
            }
        }
    };
    
    
    const handleFacebookRedirect = (url) => {
        if (url.trim()) {
            const newWindow = window.open(url, '_blank');
            if (newWindow) {
                newWindow.opener = null;
            }
        }
    };
    
    const handleLinkedinRedirect = (url) => {
        if (url.trim()) {
            const newWindow = window.open(url, '_blank');
            if (newWindow) {
                newWindow.opener = null;
            }
        }
    };
    
    const handleTwitterRedirect = (value) => {
        let url = value?.trim();
        if (!url) return;
        if (url.startsWith("@")) {
            // Only a handle was saved, e.g. "@username"
            url = `https://x.com/${url.slice(1)}`;
        } else if (!/^https?:\/\//i.test(url)) {
            // Saved without a protocol, e.g. "x.com/username" or "twitter.com/username"
            url = /^(www\.)?(twitter|x)\.com\//i.test(url) ? `https://${url}` : `https://x.com/${url}`;
        }
        const newWindow = window.open(url, '_blank');
        if (newWindow) {
            newWindow.opener = null;
        }
    };
    
    const handleWhatsappRedirect = (phoneNumber) => {
        if (phoneNumber.trim()) {
        const encodedMessage = encodeURIComponent("");
        const url = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
        const newWindow = window.open(url, '_blank');
        if (newWindow) {
            newWindow.opener = null;
        }
        }
    };
    
    const handleEmailRedirect = (email) => {
        if (email && email.trim()) {
        const encodedSubject = encodeURIComponent("");
        const encodedMessage = encodeURIComponent("");
        const mailtoUrl = `mailto:${email}?subject=${encodedSubject}&body=${encodedMessage}`;
        window.location.href = mailtoUrl;
        }
    };
    
    const handleCallRedirect = (phoneNumber) => {
        if (phoneNumber && phoneNumber.trim()) {
            const cleanedPhone = phoneNumber.trim().replace(/[\s\-()]/g, '');
            const telUrl = `tel:${cleanedPhone}`;
            window.location.href = telUrl;
        }
    };
    
    const handleCopy = () => {
        toast.success("Link copied to clipboard!");
    };
    
    const handleScroll = () => {
        const sections = document.querySelectorAll('section');
        let currentSection = '';
        sections.forEach((section) => {
        const sectionTop = section.offsetTop - headerRef?.current?.offsetHeight-25; // Offset to adjust for header height
        if (window.scrollY >= sectionTop) {
            currentSection = section.getAttribute('id');
        }
        });
        setActiveSection(currentSection);
    };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    setFavicon(home_data?.favicon)
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // The header is fixed, so pages below it must reserve exactly its height.
  // Its height varies with the data it renders (registration details, logo,
  // Distributor Login) and with wrapping at narrow widths, so measure it and
  // expose the value as --header-height instead of hardcoding an offset.
  useEffect(() => {
    const publishHeaderHeight = () => {
      const height = headerRef.current?.offsetHeight;
      if (height) {
        document.documentElement.style.setProperty('--header-height', `${height}px`);
      }
    };

    publishHeaderHeight();

    const observer = typeof ResizeObserver !== 'undefined'
      ? new ResizeObserver(publishHeaderHeight)
      : null;
    if (observer && headerRef.current) observer.observe(headerRef.current);
    window.addEventListener('resize', publishHeaderHeight);

    return () => {
      if (observer) observer.disconnect();
      window.removeEventListener('resize', publishHeaderHeight);
    };
  }, [home_data]);

    return (
        <header ref={headerRef} className="bg-white fixed z-[10] flex w-full top-0 border-b border-[#e3e3e3]">
            <nav aria-label="Global" className="flex w-full items-center py-4 px-8 max-sm:px-4 lg:px-8 lg:max-w-7xl mx-auto">
                <div className="flex max-sm:w-fit items-center justify-between">
                    <span onClick={()=>{handleNavigation('section1')}} className="-m-1.5 p-1.5">
                        <span className="sr-only">Salespanda</span>
                        {home_data?.new_microsite_extra_clt && home_data?.new_microsite_extra_clt?.custom_logo !== '' && home_data?.new_microsite_extra_clt?.custom_logo ? (
                            <img alt="" src={home_data?.new_microsite_extra_clt?.custom_logo} className="h-8 cursor-pointer w-auto" />
                        ) : (
                           <img alt="" src={home_data?.company_logo} className="h-8 cursor-pointer w-auto" />
                        )}
                    </span>
                </div>
                <div className="flex relative max-sm:flex-1 max-sm:w-auto items-center justify-end lg:hidden">
                   
                   <span className='text-base not-italic font-medium leading-7'></span>
                       {home_data?.new_microsite_extra_clt && home_data?.new_microsite_extra_clt?.DistributorLogin !== '' && home_data?.new_microsite_extra_clt?.DistributorLogin === 1 && (
                           <>
                          <button
                               type="button"
                               onClick={handleDistributorLoginMobile}
                               className="inline-flex items-center rounded-md border px-2 py-1 mr-[5px] text-xs font-semibold bg-white hover:bg-gray-50 transition-colors"
                               style={{ borderColor: siteColors.primary, color: siteColors.primary }}
                           >
                               Distributor Login
                           </button>
                           </>

                       )}
                </div>
                <div className="flex relative max-sm:w-auto items-center justify-end lg:hidden">
                    <button
                        type="button"
                        onClick={() => setMobileMenuOpen(true)}
                        className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-[#00000060]"
                    >
                        <span className='text-base not-italic font-medium leading-7'>Menu</span>
                        <ChevronDownIcon aria-hidden="true" className="h-6 w-6 text-[#00000060]" />
                    </button>
                </div>
                <PopoverGroup className="hidden lg:flex items-center lg:gap-x-24 pl-24">
                    
                    <Popover className="relative">
                        {({ open, close }) => (
                        <>
                            <PopoverButton
                                style={{ 
                                    color: (open || window.location?.pathname?.includes("category")) ? 
                                        siteColors.primary : 
                                        '#00000040'
                                }}
                                className={`text-base leading-7 flex items-center gap-x-1 focus-visible:outline-none ${
                                    (open || window.location?.pathname?.includes("category")) ? 
                                    'italic font-semibold' : 
                                    'not-italic font-medium'
                                }`}
                            >
                                {home_data?.header_tab ? home_data?.header_tab : "Category"}
                                <ChevronDownIcon
                                    aria-hidden="true"
                                    className={`h-5 w-5 flex-none focus-visible:outline-none transition-transform ${
                                    open ? 'rotate-180' : 'rotate-0'
                                    }`}
                                />
                            </PopoverButton>

                            <span className="absolute top-1/2 translate-y-[-50%] -left-20 w-16 h-[2px] bg-gray-300" />

                            <PopoverPanel
                            className={`absolute -left-8 top-full z-10 mt-3 w-screen max-w-sm listings-bar overflow-y-auto max-h-[80vh]] rounded-md bg-white shadow-lg ring-1 ring-gray-900/5 transition-all duration-200 transform ${
                                open
                                ? 'translate-y-0 opacity-100 ease-out'
                                : 'translate-y-2 opacity-0 ease-in'
                            }`}
                            >
                            <div className="p-0">
                                {category?.map((item) => (
                                <div
                                    key={item.id}
                                    className="group relative flex gap-x-6 rounded-lg p-4 text-sm cursor-pointer leading-6 hover:bg-gray-50"
                                    onClick={() => {
                                        navigate(`/category?id=${item?.id}`)
                                        close();
                                    }}
                                >
                                    <div className="mt-1 flex h-11 w-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white">
                                    <img
                                        src={item?.icon}
                                        aria-hidden="true"
                                        className="h-12 w-12 text-gray-600 group-hover:text-indigo-600"
                                    />
                                    </div>
                                    <div className="flex-auto text-left">
                                    <span className="block font-semibold text-gray-900">
                                        {item?.title}
                                        <span className="absolute inset-0" />
                                    </span>
                                    <p className="mt-1 text-gray-600">
                                        {item?.description?.slice(0,40)}{item.description.length > 40 ? "...":""}
                                    </p>
                                    </div>
                                </div>
                                ))}
                            </div>
                            </PopoverPanel>
                        </>
                        )}
                    </Popover>

                    <Button
                        style={{ 
                            color: activeSection === 'section2' ? 
                                siteColors.primary : 
                                '#00000040'
                        }}
                        className={`relative text-base leading-7 flex items-center gap-x-1 focus-visible:outline-none ${
                            activeSection === 'section2' ? 
                            'italic font-semibold' : 
                            'not-italic font-medium'
                        }`}
                        onClick={() => handleNavigation('section2')}
                    >
                        Products
                        <span className="absolute top-1/2 translate-y-[-50%] -left-20 w-16 h-[2px] bg-gray-300" />
                    </Button>
                    {home_data?.testimonials?.data?.length > 0 && <Button
                        style={{ 
                            color: activeSection === 'section3' ? 
                                siteColors.primary : 
                                '#00000040'
                        }}
                        className={`relative text-base leading-7 flex items-center gap-x-1 focus-visible:outline-none ${
                            activeSection === 'section3' ? 
                            'italic font-semibold' : 
                            'not-italic font-medium'
                        }`}
                        onClick={() => handleNavigation('section3')}
                    >
                        Testimonials
                        <span className="absolute top-1/2 translate-y-[-50%] -left-20 w-16 h-[2px] bg-gray-300" />
                    </Button>}
                    <Button
                        style={{ 
                            color: activeSection === 'section4' ? 
                                siteColors.primary : 
                                '#00000040'
                        }}
                        className={`relative text-base leading-7 flex items-center gap-x-1 focus-visible:outline-none ${
                            activeSection === 'section4' ? 
                            'italic font-semibold' : 
                            'not-italic font-medium'
                        }`}
                        onClick={() => handleNavigation('section4')}
                    >
                        Contact 
                        <span className="absolute top-1/2 translate-y-[-50%] -left-20 w-16 h-[2px] bg-gray-300" />
                    </Button>
                </PopoverGroup>
                <div className="hidden lg:grid ml-auto mr-0 grid">

                        <span onClick={()=>{handleNavigation('section1')}} className="group cursor-pointer block flex-shrink-0">
                            <div className="flex items-center text-left justify-end" style={{ display   : 'flex', justifyContent: 'flex-end' }}>
                            {home_data?.new_microsite_extra_clt && home_data?.new_microsite_extra_clt?.DistributorLogin !== '' && home_data?.new_microsite_extra_clt?.DistributorLogin === 1 && (
                                    <button
                                        type="button"
                                        onClick={handleDistributorLogin}
                                        className="inline-flex items-center rounded-md border px-2 py-1 mr-[5px] text-xs font-semibold bg-white hover:bg-gray-50 transition-colors"
                                        style={{ borderColor: siteColors.primary, color: siteColors.primary }}
                                    >
                                        Distributor Login
                                    </button>
                                )}
                                <div>
                                    <p className="text-right text-[#00000070] text-sm not-italic font-semibold leading-5">
                                        {home_data?.new_microsite_extra_clt?.registration_name_at_new_microsite_header === 1 && (
                                            <>
                                                <span
                                                    dangerouslySetInnerHTML={{
                                                        __html: home_data?.new_microsite_extra_clt?.registration_name || "",
                                                    }}
                                                />
                                                <br />
                                                <span
                                                    dangerouslySetInnerHTML={{
                                                        __html: home_data?.new_microsite_extra_clt?.registration_number || "",
                                                    }}
                                                />
                                                <br />
                                            </>
                                        )}
                                        {home_data?.microsite?.name}
                                        <br />
                                        {home_data?.microsite?.arn_no}
                                    </p>
                                </div>
                                <div  className="ml-3">
                                    {showHeaderLoader ? (
                                        <div className={`${headerAvatarSizeClass} rounded-full bg-[#e5e7eb] animate-pulse`} />
                                    ) : (
                                        <img
                                            alt="profile"
                                            src={home_data?.microsite?.profile_image}
                                            className={`inline-block ${headerAvatarSizeClass} rounded-full`}
                                        />
                                    )}
                                </div>
                            </div>
                        </span>
                        <div className=" flex mt-1 leading-4">
                            <p className="text-[12px] text-[#00000070] not-italic font-medium cursor-pointer" onClick={() => { handleEmailRedirect(home_data?.microsite?.email) }}>
                            <img src={process.env.PUBLIC_URL + '/email.svg'} className="w-[15px] h-[10px] inline-block mr-1" alt="email" />{' '}
                            {home_data?.microsite?.email?.includes('@') ? (
                                <>
                                    <span className="break-all">{home_data.microsite.email.split('@')[0]}</span>
                                    <wbr /><span className="whitespace-nowrap">@{home_data.microsite.email.split('@')[1]}</span>
                                </>
                            ) : (
                                <span className="break-all">{home_data?.microsite?.email}</span>
                            )}
                            </p>
                            <p className="text-[12px] text-[#00000070] not-italic font-medium whitespace-nowrap cursor-pointer" onClick={() => { handleCallRedirect(home_data?.microsite?.contact) }}>
                            <img src={process.env.PUBLIC_URL + '/phone.svg'} className="w-[15px] h-[11px] inline-block ml-1" alt="phone call" />  {home_data?.microsite?.contact}
                            </p>
                        </div>
                    { !window.location.pathname.includes("category") ?
                        <>
                        </>
                        :
                        <Menu as="div" className="relative inline-block text-left">
                        

                        <MenuItems
                            transition
                            className="absolute right-0 z-10 mt-2 w-64 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                        >
                            <div className="py-1">
                                <MenuItem>
                                    <div className={`w-[200%] border border-[#d9d9d9] shadow-[0px_0px_30px_5px_#95bed4] h-fit transition-all duration-500 ease-in-out bg-white absolute -top-3 rounded-xl -left-full opacity-100 z-1`}>
                                        <div className="flex">
                                            <div className="w-1/2">
                                                <img
                                                    alt=""
                                                    src={profile_data?.profile_image}
                                                    className="mx-auto h-68 p-4 w-full rounded-t-xl"
                                                />
                                                <div className="h-[100px]">
                                                    <SmallCarousel achievementData={achivements?.data}/>
                                                </div>
                                                {/* <span
                                                    onClick={toggleCard}
                                                    className={`absolute -left-5 top-1/2 bg-[#E85325] transform -translate-y-1/2 cursor-pointer rounded-full`}
                                                >
                                                    <ArrowRight className={`p-2 text-[40px] transition-all text-white duration-500 ease-in-out`} />
                                                </span> */}
                                            </div>
                                            <div className="w-1/2 before:border-l before:h-full before:absolute before:border-[#d9d9d9]">
                                                <div className="px-4 pb-4 space-y-1 mt-2 flex flex-col h-full">
                                                    <h3 className="text-black text-3xl not-italic font-medium leading-10">
                                                        {profile_data?.name}
                                                    </h3>
                                                    <p style={{ color: siteColors.primary }} className="text-base not-italic font-medium leading-6 capitalize">
                                                        {profile_data?.designation?.toLowerCase()}
                                                    </p>
                                                    <p className="text-[#00000070] text-sm not-italic font-normal leading-[132%]">
                                                        {profile_data?.about.slice(0, 300)}
                                                    </p>
                                                    {/* Add flex-grow to push the content above the div with icons */}
                                                    <div className="flex-grow"></div>
                                                    <div className="pb-4 space-y-1 mt-auto">
                                                        <div className="grid grid-cols-5 py-1">
                                                            <img onClick={() => { handleLinkedinRedirect(profile_data?.linkedin_page) }} src={LinkedInImg} className="w-10 h-10 cursor-pointer rounded-full mt-2" alt="linkedin" />
                                                            <img onClick={() => { handleFacebookRedirect(profile_data?.facebook_page) }} src={Facebookmg} className="w-10 h-10 cursor-pointer mt-2" alt="Facebook" />
                                                            <img onClick={() => { handleTwitterRedirect(profile_data?.twitter_page) }} src={TwitterImg} className="w-10 h-10 cursor-pointer mt-2" alt="Twitter" />
                                                            <img onClick={() => { handleWhatsappRedirect(profile_data?.contact) }} src={WhatsappIconImg} className="w-10 h-10 cursor-pointer mt-2" alt="whatsapp" />
                                                            <img onClick={() => { handleEmailRedirect(profile_data?.email) }} src={EmailIconImg} className="w-10 h-10 cursor-pointer mt-2" alt="email" />
                                                            {isMobile && <img onClick={() => { handleCallRedirect(profile_data?.contact) }} src={PhoneIconImg} className="w-10 h-10 cursor-pointer mt-2" alt="phone" />}
                                                            <CopyToClipboard text={window.location.origin + window.location.pathname.replace("/category","")} onCopy={handleCopy}>
                                                                <Link45deg className='text-[39px] mt-2 cursor-pointer text-[#b8b8b8] p-1 bg-[#fff] border-2 border-[#b8b8b8] rounded-full'/>
                                                            </CopyToClipboard>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </MenuItem>
                            </div>
                        </MenuItems>
                        </Menu>
                    }
                </div>
            </nav>
            
            <Dialog open={mobileMenuOpen} onClose={setMobileMenuOpen} className="relative z-50 lg:hidden">
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-gray-900/80 transition-opacity duration-300 ease-linear data-[closed]:opacity-0"
                />

                <div className="fixed inset-0 flex">
                    <DialogPanel
                    transition
                    className="relative mr-16 flex w-full max-w-xs flex-1 transform transition duration-300 ease-in-out data-[closed]:-translate-x-full"
                    >
                    <TransitionChild>
                        <div className="absolute left-full top-0 flex w-16 justify-center pt-5 duration-300 ease-in-out data-[closed]:opacity-0">
                        <button type="button" onClick={() => setMobileMenuOpen(false)} className="-m-2.5 p-2.5">
                            <span className="sr-only">Close sidebar</span>
                            <XMarkIcon aria-hidden="true" className="size-6 text-white" />
                        </button>
                        </div>
                    </TransitionChild>

                    <div className="flex grow flex-col bg-white px-6 py-2">
                        <div
                            onClick={() => {
                                navigate("/")            
                                handleNavigation('section1');
                                setMobileMenuOpen(false);                                    
                            }}
                        className="border-b border-gray-200 flex-shrink-0 pt-4 pb-6 items-center flex justify-between"
                        >
                        


{home_data?.new_microsite_extra_clt && home_data?.new_microsite_extra_clt?.custom_logo !== '' && home_data?.new_microsite_extra_clt?.custom_logo ? (
                            <img alt="" src={home_data?.new_microsite_extra_clt?.custom_logo} className="header-logo w-32" />
                        ) : (
                           <img alt="" src={home_data?.company_logo} className="header-logo w-32" />
                        )}


                        </div>

                        <div>
                            <div
                                style={{ 
                                    color: openCategory ? 
                                        siteColors.primary : 
                                        '#00000080'
                                }}
                                className={`text-base flex justify-between font-[600] py-4 ${
                                    openCategory ? 'italic' : 'not-italic'
                                }`}
                                onClick={() => setOpenCategory(!openCategory)}
                            >
                                <span>Category</span>
                                <ChevronDownIcon
                                    aria-hidden="true"
                                    className={`h-5 w-5 flex-none transition-transform ${
                                    openCategory ? 'rotate-180' : 'rotate-0'
                                    }`}
                                />
                            </div>
                                        
                            {category?.length > 0 && <nav className={`transition-all duration-500 ease-in-out overflow-hidden ${openCategory ? "max-h-0":"max-h-[300px] overflow-y-auto"}`}>
                                <ul role="list" className='space-y-1'>
                                    {category?.map((item) => (
                                        <div
                                            key={item.id}
                                            className="border-b border-[#2167A740] flex bg-white gap-x-3 p-2 text-sm cursor-pointer leading-5"
                                            onClick={() => {
                                                navigate(`/category?id=${item?.id}`)
                                                setMobileMenuOpen(false); 
                                            }}
                                        >
                                            <div className="mt-1 flex items-center justify-center rounded-lg bg-transparent">
                                                <img
                                                    src={item?.icon}
                                                    aria-hidden="true"
                                                    className="h-[50px] w-[50px] object-contain max-w-fit"
                                                />
                                            </div>
                                            <div>
                                                <span className="block leading-2 font-semibold text-[#00000080]">
                                                    {item?.title}
                                                </span>
                                                <p className="text-gray-600 text-[12px] leading-4">
                                                    {item?.description?.slice(0,50)}{item.description.length > 20 ? "...":""}
                                                </p>
                                            </div>
                                        </div>
                                    ))}
                                </ul>
                            </nav>}         
                                        
                            <div
                                style={{ 
                                    color: activeSection === 'section2' ? 
                                        siteColors.primary : 
                                        '#00000080'
                                }}
                                className={`text-base flex justify-between pr-6 font-[600] py-4 ${
                                    activeSection === 'section2' ? 
                                    'italic font-semibold' : 
                                    'not-italic font-semibold'
                                }`}
                                onClick={() => {
                                    handleNavigation('section2');
                                    setMobileMenuOpen(false);                                    
                                }}
                            >
                                <span>Products</span>
                            </div>
                            {home_data?.testimonials?.data?.length > 0 && <div
                                style={{ 
                                    color: activeSection === 'section3' ? 
                                        siteColors.primary : 
                                        '#00000080'
                                }}
                                className={`text-base flex justify-between pr-6 font-[600] py-4 ${
                                    activeSection === 'section3' ? 
                                    'italic font-semibold' : 
                                    'not-italic font-semibold'
                                }`}
                                onClick={() => {
                                    handleNavigation('section3');
                                    setMobileMenuOpen(false);                                    
                                }}
                            >
                                <span>Testimonials</span>
                            </div> } 
                            <div
                                style={{ 
                                    color: activeSection === 'section4' ? 
                                        siteColors.primary : 
                                        '#00000080'
                                }}
                                className={`text-base flex justify-between pr-6 font-[600] py-4 ${
                                    activeSection === 'section4' ? 
                                    'italic font-semibold' : 
                                    'not-italic font-semibold'
                                }`}
                                onClick={() => {
                                    handleNavigation('section4');
                                    setMobileMenuOpen(false);                                    
                                }}
                            >
                                <span>Contact</span>
                            </div>                                          
                        </div>                                    
                    </div> 
                    </DialogPanel>
                </div>
            </Dialog>
        </header>
  );
};

export default Header;